/**
 * Typsicherer API-Client (Hono RPC) und gemeinsame Fehlerbehandlung.
 * Alle Aufrufe laufen über `rufe()`: wirft `ApiFehler` mit der Meldung des Servers.
 */
import { hc } from "hono/client";
import type { ApiTyp } from "../../worker/index";

export const api = hc<ApiTyp>("/", { init: { credentials: "same-origin" } });

export class ApiFehler extends Error {
  constructor(
    message: string,
    readonly status: number,
    readonly code?: string,
  ) {
    super(message);
  }
}

/** Entpackt eine Hono-Antwort; bei Fehlerstatus wird die Server-Meldung geworfen. */
export async function rufe<T>(antwort: Promise<Response>): Promise<T> {
  let res: Response;
  try {
    res = await antwort;
  } catch {
    throw new ApiFehler("Keine Verbindung. Bitte Internet prüfen und erneut versuchen.", 0);
  }
  if (!res.ok) {
    let meldung = "Da ist etwas schiefgegangen. Bitte noch einmal versuchen.";
    let code: string | undefined;
    try {
      const body = (await res.json()) as { fehler?: string; code?: string; error?: { issues?: { message: string }[] } };
      if (body.fehler) meldung = body.fehler;
      else if (body.error?.issues?.[0]?.message) meldung = body.error.issues[0].message;
      code = body.code;
    } catch {
      // kein JSON
    }
    // Zweiter Faktor fehlt in dieser Sitzung → zur Code-Eingabe (einmal, ohne Schleife)
    if (code === "zweiter_faktor" && !window.location.pathname.startsWith("/anmelden/code")) {
      window.location.assign(`/anmelden/code?weiter=${encodeURIComponent(window.location.pathname)}`);
    }
    throw new ApiFehler(meldung, res.status, code);
  }
  return (await res.json()) as T;
}
